import { DateTime } from "luxon"
import { MUIDataTableOptions } from "mui-datatables";

export const tableOptions: MUIDataTableOptions = {
    download: false,
    print: false
}

export function utcToLocal(date: string) {
    return DateTime.fromISO(date, { zone: 'UTC' }).toLocal()
}

export function insertIf<A>(condition: boolean | undefined, ...elements: A[]) { // (A)
    return condition ? elements : [];
}